module.exports = "../../../../platform/assets/pageMainIcon/ig-basic-archives-1.svg";